import React, { useState, useEffect } from "react";
import { getSubdomainPath, UCWords } from "../../utils/helpers";
import { useLocation, Link } from "react-router-dom";
import { LOAD_AREAS_LIST } from "../../utils/apiPath";
import { imgPath } from "../../utils/imagePath";
import { agent } from "../../utils/agent";
import { Tooltip } from "@mui/material";
import rainbow from '../../assets/images/rainbow.png'
import config from "../../config";
import PropTypes from "prop-types";

const Filter = (props) => {

  const { setting, setSelectedDomain, selectedDomain, setLgbtqDiscussion, lgbtqDiscussion, setCertifiedCoach, certifiedCoach, setMentalHealth, mentalHealth, setSearchDomain, resetPage } = props;

  const [areas, setAreas] = useState([]);
  const [role_active_user] = useState('active_mentor');
  const getAreasData = (page = 1) => {
    agent
      .get(LOAD_AREAS_LIST, {})
      .then((res) => {
        setAreas(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const location = useLocation();

  useEffect(() => {
    getAreasData();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("domains")) {
      setSearchDomain(params.get("domains"));
    }
    if (params.get("mf_mental_health")) {
      setMentalHealth(params.get("mf_mental_health"));
    }
    if (params.get("mf_certified_coach")) {
      setCertifiedCoach(params.get("mf_certified_coach"));
    }
    if (params.get("lgbtq_discussion")) {
      setLgbtqDiscussion(params.get("lgbtq_discussion"));
    }
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const domains = params.get("domains");

    if (domains) {
      setSelectedDomain(domains.split(",")); // convert to array
    } else {
      setSelectedDomain([]);
    }
  }, [location]);

  const setSelectedDomainArray = (e) => {
    const val = e.target.value;
    const { checked } = e.target;
    const updatedDomains = checked
      ? [...selectedDomain, val]
      : selectedDomain.filter((id) => id !== val);

    // Inform parent to update URL + fetch
    props.onFilterChange({ domains: updatedDomains });
  };

  const setSelectedHealth = (e, type) => {
    const isChecked = e.target.checked;
    const value = isChecked ? "1" : "";

    // Update local state too, so checkbox reflects immediately
    if (type === "mf_mental_health") setMentalHealth(value);
    if (type === "mf_certified_coach") setCertifiedCoach(value);
    if (type === "lgbtq_discussion") setLgbtqDiscussion(value);

    // Notify parent to update URL and reload mentors list
    props.onFilterChange({ [type]: value });
  };


  const getFieldValueAndStatus = (field, active_user) => {
    return setting?.registration_steps_fields?.find(item => item.reg_key === field)?.status == 1;
  };
  const subDomainPath = getSubdomainPath();

  return (
    <div className="sidebar">
      <div className="sidebar_heading seprator">
        <h3 className="d-flex align-items-center">
          Filters
          <Link to="" onClick={resetPage} className="link ms-auto">
            {"Reset Filters"}
          </Link>
        </h3>
      </div>
      <div className="sidebar_toggle">
        <div className="seprator">
          {subDomainPath === "siduat" || subDomainPath === "siddev" || subDomainPath === "sid" ? "" :
            <h6>Select Job Function</h6>
          }
          <ul>
            {/* {areas && */}
            {areas.map((item, key) => (
              <li key={item.id}>
                <span className="custom_check">
                  {UCWords(item.name)} &nbsp;{" "}
                  <input
                    value={item.id}
                    type="checkbox"
                    onClick={(e) => setSelectedDomainArray(e)}
                    checked={selectedDomain?.includes(item?.id?.toString())}
                  ></input>
                  <span className="check_indicator">&nbsp;</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
        {(getFieldValueAndStatus('mf_mental_health', role_active_user) || getFieldValueAndStatus('mf_certified_coach', role_active_user) || getFieldValueAndStatus('lgbtq_discussion', role_active_user)) && <div className="seprator health_check">
          <ul>
            {getFieldValueAndStatus('mf_mental_health', role_active_user) &&
              <li>
                <span className="custom_check">
                  &nbsp;{" "}
                  <input
                    value={mentalHealth ? 1 : 0}
                    type="checkbox"
                    onClick={(e) => setSelectedHealth(e, "mf_mental_health")}
                    checked={mentalHealth}
                  ></input>
                  <span className="check_indicator">&nbsp;</span>
                </span>
                <Tooltip
                  size="4xl"
                  title={<h5>{config?.mf_mental_health}</h5>}
                  describeChild
                  arrow
                >
                  <img alt=""
                    src={imgPath + "usermind.svg"}
                  />
                </Tooltip>{" "}
              </li>
            }
            {getFieldValueAndStatus('mf_certified_coach', role_active_user) &&
              <li>
                <span className="custom_check">
                  &nbsp;{" "}
                  <input
                    type="checkbox"
                    value={certifiedCoach}
                    onClick={(e) => setSelectedHealth(e, "mf_certified_coach")}
                    checked={certifiedCoach}
                  ></input>
                  <span className="check_indicator">&nbsp;</span>
                </span>
                <Tooltip
                  size="4xl"
                  title={<h5>{config?.mf_certified_coach}</h5>}
                  describeChild
                  arrow
                >
                  <img alt=""
                    src={
                      imgPath + "useraward.svg"
                    }
                  />
                </Tooltip>{" "}
              </li>
            }
            {getFieldValueAndStatus('lgbtq_discussion', role_active_user) &&
              <li>
                <span className="custom_check">
                  &nbsp;{" "}
                  <input
                    type="checkbox"
                    value='lgbtq_discussion'
                    id="lgbtq_discussion"
                    onChange={(e) => setSelectedHealth(e, "lgbtq_discussion")}
                    checked={lgbtqDiscussion}
                  ></input>
                  <span className="check_indicator">&nbsp;</span>
                </span>
                <Tooltip
                  size="4xl"
                  title={<h5>{config?.LGBTQ_discussion}</h5>}
                  describeChild
                  arrow
                >
                  <img alt=""
                    src={rainbow}
                  />
                </Tooltip>{" "}
              </li>
            }
          </ul>
        </div>}
      </div>
    </div>
  );
};

Filter.propTypes = {
  setting: PropTypes.shape({
    registration_steps_fields: PropTypes.shape({
      find: PropTypes.func,
    }),
  }).isRequired,
  selectedDomain: PropTypes.shape({
    map: PropTypes.func,
    filter: PropTypes.func,
    includes: PropTypes.func,
  }).isRequired,
  setSelectedDomain: PropTypes.func.isRequired,
  lgbtqDiscussion: PropTypes.string.isRequired,
  setLgbtqDiscussion: PropTypes.func.isRequired,
  certifiedCoach: PropTypes.string.isRequired,
  setCertifiedCoach: PropTypes.func.isRequired,
  mentalHealth: PropTypes.string.isRequired,
  setMentalHealth: PropTypes.func.isRequired,
  setSearchDomain: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  resetPage: PropTypes.func.isRequired,
};

export default Filter;
